import React from "react";
//Cookie token
import cookie from "react-cookies";
//Router redirect
import { useHistory } from "react-router-dom";

const OrderUpdate = () => {
  //Redirect if not logged in
  let history = useHistory();
  const token = cookie.load("usertk");

  return (
    <>
      {!token ? (
        history.push("/")
      ) : (
        <>
          <h1>Editar Pedido</h1>
          <h1>Editar Pedido</h1>
          <h1>Editar Pedido</h1>
          <h1>Editar Pedido</h1>
          <h1>Editar Pedido</h1>
          <h1>Editar Pedido</h1>
          <h1>Editar Pedido</h1>
          <h1>Editar Pedido</h1>
          <h1>Editar Pedido</h1>
          <h1>Editar Pedido</h1>
        </>
      )}
    </>
  );
};

export default OrderUpdate;
